import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPartnerProfileStyle0 = cosmosIconCss;

const CosmosIconPartnerProfile$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPartnerProfile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3f8c66a23142a94d71db9e89bad10c07085cd81a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9661832f0d1c88ce4ce3edc2b5ca1f64e7cbf746', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '62cca2b140d4b92b3c8d0d565b60b873f84101ff', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.001 3.75c.74 0 1.445.32 1.933.878.468.61.662 1.387.537 2.146l-.179 1.7a2.291 2.291 0 0 1-4.582-.001l-.182-1.713a2.778 2.778 0 0 1 .54-2.134A2.57 2.57 0 0 1 15 3.75Zm-6.37 10.721a.324.324 0 0 1 .266-.021 3.898 3.898 0 0 1 2.602 3.463.323.323 0 0 1-.324.337h-8.35a.322.322 0 0 1-.325-.337 3.897 3.897 0 0 1 2.602-3.463.324.324 0 0 1 .267.021 3.56 3.56 0 0 0 3.261 0Zm.302-6.842A2.428 2.428 0 0 0 7 6.752a2.428 2.428 0 0 0-1.933.876 2.776 2.776 0 0 0-.54 2.133l.181 1.712a2.291 2.291 0 1 0 4.582.001l.18-1.698a2.784 2.784 0 0 0-.537-2.147Zm7.696 3.842a.326.326 0 0 1 .27-.021 3.897 3.897 0 0 1 2.6 3.46.325.325 0 0 1-.325.34h-6.758a.494.494 0 0 1-.405-.217 5.317 5.317 0 0 0-.955-1.039.501.501 0 0 1-.155-.597 3.969 3.969 0 0 1 2.2-1.947.326.326 0 0 1 .269.021 3.559 3.559 0 0 0 3.26 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPartnerProfileStyle0; }
}, [1, "cosmos-icon-partner-profile", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-partner-profile"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-partner-profile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPartnerProfile$1);
            }
            break;
    } });
}

const CosmosIconPartnerProfile = CosmosIconPartnerProfile$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPartnerProfile, defineCustomElement };
